module.exports = __webpack_public_path__ + "static/media/02_tn.e0d50f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/02_tn.jpg
// module id = 140
// module chunks = 0